import makeRequest from "../../../makeRequest";

const url = '/api/user/availability/list'

export async function getAvailability(data: any, headers?: Record<string, string>) {
    return makeRequest('POST', url, data, headers);
}